import { render, staticRenderFns } from "./RegionMap.vue?vue&type=template&id=94c8ff6c"
import script from "./RegionMap.vue?vue&type=script&lang=js"
export * from "./RegionMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports